import { featureMessages } from './messages/features';

export type Locale = 'th' | 'en';

export const DEFAULT_LOCALE: Locale = 'th';

export const messages: Record<Locale, Record<string, string>> = {
  th: {
    'common.cancel': 'ยกเลิก',
    'common.confirm': 'ยืนยัน',
    'common.confirmDefault': 'ยืนยันการดำเนินการ',
    'common.confirmDelete': 'ยืนยันการลบรายการ',
    'common.save': 'บันทึกการตั้งค่าทั่วไป',
    'common.saving': 'กำลังบันทึก...',
    'common.search': 'ค้นหา',
    'common.more': 'เพิ่มเติม',
    'common.moreMenu': 'เมนูเพิ่มเติม',
    'common.logout': 'ออกจากระบบ',
    'common.openMenu': 'เปิดเมนู',
    'common.closeMenu': 'ปิดเมนู',
    'common.noAccessTitle': 'ไม่มีสิทธิ์เข้าถึงหน้านี้',
    'common.noAccessDesc': 'บัญชีของคุณไม่มีระดับสิทธิ์ที่เพียงพอสำหรับเข้าใช้งานหน้านี้',
    'common.saved': 'บันทึกการตั้งค่าเรียบร้อยแล้ว',
    'common.saveError': 'เกิดข้อผิดพลาดในการบันทึกการตั้งค่า',
    'common.ownerOnly': 'เฉพาะ Owner',
    'common.clickSave': 'กดบันทึก',
    'common.loading': 'กำลังโหลด...',
    'common.refreshData': 'รีเฟรชข้อมูล',

    'nav.section.overview': 'ภาพรวม',
    'nav.section.fivem': 'FiveM Server',
    'nav.section.productivity': 'Productivity',
    'nav.section.system': 'ระบบ',
    'nav.dashboard': 'แดชบอร์ด',
    'nav.server': 'จัดการทีมงาน & เซิร์ฟเวอร์',
    'nav.changelog': 'อัปเดตเซิร์ฟเวอร์',
    'nav.project': 'โปรเจกต์',
    'nav.habits': 'งานของฉัน',
    'nav.finance': 'การเงิน',
    'nav.calendar': 'ปฏิทิน',
    'nav.images': 'ฝากรูป & CDN',
    'nav.audit': 'Audit Log',
    'nav.settings': 'ตั้งค่า & ธีมระบบ',
    'nav.team': 'ทีม',
    'nav.imagesShort': 'ฝากรูป',
    'nav.patch': 'แพตช์',
    'nav.settingsShort': 'ตั้งค่า',

    'views.dashboard.title': 'ภาพรวมระบบ',
    'views.dashboard.subtitle': 'สถิติและข้อมูลภาพรวมของระบบทั้งหมด',
    'views.server.title': 'จัดการทีมงาน & เซิร์ฟเวอร์',
    'views.server.subtitle': 'ข้อมูลทีมงาน บทบาทหน้าที่ และส่วนแบ่งเปอร์เซ็นรายได้',
    'views.project.title': 'โปรเจกต์ (Projects)',
    'views.project.subtitle': 'จัดการงานแยกตามโปรเจกต์ วางแผนและติดตามความคืบหน้า',
    'views.habits.title': 'งานของฉัน (Task)',
    'views.habits.subtitle': 'กำหนดงานที่ต้องทำของตัวเอง แยกหมวดหมู่และวางไทมไลน์',
    'views.finance.title': 'การเงิน & ปันผล',
    'views.finance.subtitle': 'ระบบจัดการรายรับรายจ่ายและการหารายได้',
    'views.calendar.title': 'ปฏิทินทีม',
    'views.calendar.subtitle': 'ตารางการประชุมและนัดหมายกิจกรรม',
    'views.images.title': 'ฝากรูป & ตัดต่อ (CDN)',
    'views.images.subtitle': 'ระบบย่อและฝากรูปภาพความเร็วสูง',
    'views.changelog.title': 'อัปเดตและแพตช์โน้ต',
    'views.changelog.subtitle': 'ประวัติการอัปเดตระบบและการแก้ไข',
    'views.settings.title': 'การตั้งค่าระบบ',
    'views.settings.subtitle': 'ตั้งค่าทั่วไป การแจ้งเตือน และจัดการบุคลากร',
    'views.audit.title': 'Audit Log (ประวัติ)',
    'views.audit.subtitle': 'บันทึกการกระทำทั้งหมดในระบบ',

    'settings.pageTitle': 'ตั้งค่าระบบ & ปรับแต่งธีม',
    'settings.general': 'ตั้งค่าทั่วไป (General Config)',
    'settings.generalDescEdit': 'บันทึกลงฐานข้อมูล (ใช้ร่วมกันทั้งทีม) — ชื่อเซิร์ฟเวอร์จะแสดงในแถบเมนู',
    'settings.generalDescRead': 'ดูได้อย่างเดียว — เฉพาะ Owner เท่านั้นที่แก้ไขได้',
    'settings.serverName': 'ชื่อเซิร์ฟเวอร์ (Server Name)',
    'settings.budgetThreshold': 'เกณฑ์แจ้งเตือนรายจ่ายรายเดือน (บาท)',
    'settings.budgetHint': 'แจ้งเตือนเมื่อรายจ่ายเดือนนี้ถึงเกณฑ์',
    'settings.budgetPlaceholder': '0 = ปิดการแจ้งเตือน',
    'settings.discordEnable': 'เปิดใช้งานแจ้งเตือน Discord',
    'settings.layout': 'ปรับแต่งรูปแบบ (Layout Customization)',
    'settings.language': 'ภาษา (Language)',
    'settings.languageDesc': 'เลือกภาษาที่แสดงในระบบ แล้วกดบันทึกเพื่อปรับใช้ — จดจำเฉพาะบัญชีของคุณ',
    'settings.langTh': 'ไทย (Thai)',
    'settings.langThDesc': 'ภาษาไทย (ค่าเริ่มต้น)',
    'settings.langEn': 'English',
    'settings.langEnDesc': 'Display UI in English',
    'settings.themeMode': 'โหมดธีม (Theme Mode)',
    'settings.themeDesc': 'เลือกโหมดสว่างหรือมืด แล้วกดบันทึกเพื่อปรับใช้ — ระบบจะจดจำไว้เฉพาะบัญชีของคุณ',
    'settings.themeDark': 'โหมดมืด (Night)',
    'settings.themeDarkDesc': 'ธีมดำคู่ขาว (ค่าเริ่มต้น)',
    'settings.themeLight': 'โหมดสว่าง (Light)',
    'settings.themeLightDesc': 'ธีมพื้นหลังสว่าง อ่านง่ายตอนกลางวัน',
    'settings.menuPosition': 'ตำแหน่งเมนู (Menu Position)',
    'settings.menuDesc': 'เลือกตำแหน่งเมนู แล้วกดบันทึกเพื่อปรับใช้ — ระบบจะจดจำไว้เฉพาะบัญชีของคุณเท่านั้น',
    'settings.menuSidebar': 'เมนูด้านซ้าย (Sidebar)',
    'settings.menuSidebarDesc': 'เมนูแบบแถบด้านซ้าย (ค่าเริ่มต้น)',
    'settings.menuTopbar': 'เมนูด้านบน (Top bar)',
    'settings.menuTopbarDesc': 'ย้ายเมนูไปเป็นแถบแนวนอนด้านบน',

    ...featureMessages.th,
  },
  en: {
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.confirmDefault': 'Confirm action',
    'common.confirmDelete': 'Confirm deletion',
    'common.save': 'Save settings',
    'common.saving': 'Saving...',
    'common.search': 'Search',
    'common.more': 'More',
    'common.moreMenu': 'More menu',
    'common.logout': 'Log out',
    'common.openMenu': 'Open menu',
    'common.closeMenu': 'Close menu',
    'common.noAccessTitle': 'Access denied',
    'common.noAccessDesc': 'Your account does not have permission to view this page.',
    'common.saved': 'Settings saved successfully',
    'common.saveError': 'Failed to save settings',
    'common.ownerOnly': 'Owner only',
    'common.clickSave': 'click Save',
    'common.loading': 'Loading...',
    'common.refreshData': 'Refresh data',

    'nav.section.overview': 'Overview',
    'nav.section.fivem': 'FiveM Server',
    'nav.section.productivity': 'Productivity',
    'nav.section.system': 'System',
    'nav.dashboard': 'Dashboard',
    'nav.server': 'Team & Server',
    'nav.changelog': 'Server updates',
    'nav.project': 'Projects',
    'nav.habits': 'My tasks',
    'nav.finance': 'Finance',
    'nav.calendar': 'Calendar',
    'nav.images': 'Images & CDN',
    'nav.audit': 'Audit Log',
    'nav.settings': 'Settings & theme',
    'nav.team': 'Team',
    'nav.imagesShort': 'Images',
    'nav.patch': 'Patch notes',
    'nav.settingsShort': 'Settings',

    'views.dashboard.title': 'Dashboard',
    'views.dashboard.subtitle': 'System-wide stats and overview',
    'views.server.title': 'Team & server management',
    'views.server.subtitle': 'Staff roles, duties, and revenue share',
    'views.project.title': 'Projects',
    'views.project.subtitle': 'Manage work by project and track progress',
    'views.habits.title': 'My tasks',
    'views.habits.subtitle': 'Personal tasks by category and timeline',
    'views.finance.title': 'Finance & revenue share',
    'views.finance.subtitle': 'Income, expenses, and profit distribution',
    'views.calendar.title': 'Team calendar',
    'views.calendar.subtitle': 'Meetings and scheduled events',
    'views.images.title': 'Images & CDN',
    'views.images.subtitle': 'Fast image hosting and tools',
    'views.changelog.title': 'Updates & patch notes',
    'views.changelog.subtitle': 'System update history',
    'views.settings.title': 'System settings',
    'views.settings.subtitle': 'General config, notifications, and staff',
    'views.audit.title': 'Audit log',
    'views.audit.subtitle': 'Full activity history',

    'settings.pageTitle': 'Settings & appearance',
    'settings.general': 'General config',
    'settings.generalDescEdit': 'Saved to the database (shared team-wide) — server name appears in the menu',
    'settings.generalDescRead': 'Read-only — only Owner can edit',
    'settings.serverName': 'Server name',
    'settings.budgetThreshold': 'Monthly expense alert threshold (THB)',
    'settings.budgetHint': 'Notify when this month\'s expenses reach the threshold',
    'settings.budgetPlaceholder': '0 = disable alerts',
    'settings.discordEnable': 'Enable Discord notifications',
    'settings.layout': 'Layout customization',
    'settings.language': 'Language',
    'settings.languageDesc': 'Choose display language, then Save — stored per account on this device',
    'settings.langTh': 'Thai',
    'settings.langThDesc': 'Thai (default)',
    'settings.langEn': 'English',
    'settings.langEnDesc': 'Display UI in English',
    'settings.themeMode': 'Theme mode',
    'settings.themeDesc': 'Choose light or dark mode, then Save — stored per account',
    'settings.themeDark': 'Dark (Night)',
    'settings.themeDarkDesc': 'Dark background (default)',
    'settings.themeLight': 'Light',
    'settings.themeLightDesc': 'Light background for daytime use',
    'settings.menuPosition': 'Menu position',
    'settings.menuDesc': 'Choose menu layout, then Save — stored per account only',
    'settings.menuSidebar': 'Sidebar',
    'settings.menuSidebarDesc': 'Vertical menu on the left (default)',
    'settings.menuTopbar': 'Top bar',
    'settings.menuTopbarDesc': 'Horizontal menu at the top',

    ...featureMessages.en,
  },
};
